import { Injectable } from '@angular/core';
import { TealiumUtagService } from 'src/app/tealium/utag.service';
import { environment } from 'src/environments/environment';
import { IEventLinkTealium } from '../interfaces/event-link-tealium.interface';
import { Router } from '@angular/router';
import { IEventViewTealium } from '../interfaces/event-view-tealium.interface';
import { CustomerDataService } from './customer-data.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticService {
  constructor(
    public tealium: TealiumUtagService,
    private router: Router,
    private customerDataService: CustomerDataService
  ) {
    this.tealium.setConfig({
      account: environment.account,
      profile: environment.profile,
      environment: environment.tealiumEnvironment,
      sync: false
    });

    this.tealium.setConfig({
      account: environment.account,
      profile: environment.profile,
      environment: environment.tealiumEnvironment,
      sync: true
    });

    if (environment.tealium.enable) {
      this.tealium.createTagSync();
    }
  }

  public uTagLink(label: string): void {
    const event: IEventLinkTealium = {
      event_category: 'CDT',
      event_action: `/abrir-cdt-avvillas${this.router.url}`,
      event_label: label
    };

    if (environment.tealium.enable) {
      this.tealium.link(event);
    }
  }

  // se contempla solo utilizar tracking de eventos de tipo link para tener compatibilidad entre las 2 plataformas de analítica
  // GAU (Google Analytics Universal) y GA4 (Google Analytics version 4)
  public uTagLinkError(label: string, title: string): void {
    let eventLabel: string = title + ' ' + label;
    const limitCharacters: number = 100;
    if (eventLabel.length > limitCharacters) {
      eventLabel = eventLabel.substring(0, limitCharacters - 3);
      eventLabel += '...';
    }

    let transactionId = 'No definido';
    if (this.customerDataService.customerData !== undefined) {
      transactionId = this.customerDataService.customerData.transactionId;
    }

    const event = {
      event_category: 'CDT',
      event_action: `/abrir-cdt-avvillas${this.router.url}`, // ruta donde esta sucediendo el evento
      event_label: eventLabel, // descripcion de la interaccion o evento con error, limitado a 100 caracteres
      tealium_event: title, // titulo del evento con error
      transactionId
    };

    if (environment.tealium.enable) {
      this.tealium.link(event);
    }
  }

  public pageViewEvent(path: string): void {
    const event: IEventViewTealium = {
      event: 'view',
      pagePath: '/abrir-cdt-avvillas' + path,
      pageTitle: path
    };

    if (environment.tealium.enable) {
      this.tealium.track('view', event);
    }
  }

  public pageViewEventError(path: string, label: string): void {
    const event = {
      pagePath: '/abrir-cdt-avvillas' + path, // pagina de error
      pageTitle: path, // pagina de error
      tealium_event: 'error_page', // titulo del evento con error
      event_label: label // descripcion de porque se envio a la pagina de error, limitarlo a 100 caracteres
    };

    if (environment.tealium.enable) {
      this.tealium.track('view', event);
    }
  }
}
